/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    User,
    Briefcase,
    Landmark,
    BrainCircuit,
    Building2
} from "lucide-react";

const audiences = [
    {
        title: "Retail Investors",
        icon: User,
        description:
            "Track investments, benchmark performance, discover opportunities and make informed decisions.",
        features: [
            "Portfolio Tracking",
            "Stock Research",
            "Mutual Fund Analytics"
        ]
    },

    {
        title: "Financial Advisors",
        icon: Briefcase,
        description:
            "Deliver data-backed recommendations with advanced portfolio and risk analytics.",
        features: [
            "Client Portfolios",
            "Research Dashboard",
            "Risk Analytics"
        ]
    },

    {
        title: "Mutual Fund Distributors",
        icon: Landmark,
        description:
            "Compare funds, analyze performance and streamline investment recommendations.",
        features: [
            "Fund Comparison",
            "Scheme Analytics",
            "Investment Tracking"
        ]
    },

    {
        title: "Traders & Quants",
        icon: BrainCircuit,
        description:
            "Build strategies, analyze derivatives and explore market microstructure.",
        features: [
            "Options Analytics",
            "Backtesting",
            "Quant Research"
        ]
    },

    {
        title: "Institutions",
        icon: Building2,
        description:
            "Monitor multi-asset portfolios with enterprise-grade analytics and reporting.",
        features: [
            "Risk Monitoring",
            "Performance Attribution",
            "Scenario Analysis"
        ]
    }
];

export default function AudienceSection() {

    return (

        <section className="mb-24">

            <div className="text-center mb-12">

                <h2 className="
                    text-4xl
                    font-bold
                    text-slate-900
                    mb-4
                ">
                    Built For Every Market Participant
                </h2>

                <p className="
                    text-lg
                    text-slate-600
                    max-w-3xl
                    mx-auto
                ">
                    From individual investors to institutions,
                    Orion Analytics provides professional-grade
                    market intelligence and portfolio analytics.
                </p>

            </div>

            <div className="
                grid
                md:grid-cols-2
                xl:grid-cols-3
                gap-8
            ">

                {audiences.map((item, idx) => {

                    const Icon = item.icon;

                    return (

                        <div
                            key={idx}
                            className="
                                group
                                bg-white
                                rounded-3xl
                                border
                                border-slate-200
                                p-8
                                shadow-sm
                                hover:shadow-xl
                                hover:-translate-y-2
                                transition-all
                                duration-300
                            "
                        >

                            <div className="
                                w-14
                                h-14
                                rounded-2xl
                                bg-blue-50
                                flex
                                items-center
                                justify-center
                                mb-6
                                group-hover:bg-blue-100
                            ">

                                <Icon
                                    size={28}
                                    className="text-blue-600"
                                />

                            </div>

                            <h3 className="
                                text-xl
                                font-bold
                                text-slate-900
                                mb-3
                            ">
                                {item.title}
                            </h3>

                            <p className="
                                text-slate-600
                                mb-6
                                leading-relaxed
                            ">
                                {item.description}
                            </p>

                            <div className="space-y-3">

                                {item.features.map((feature) => (

                                    <div
                                        key={feature}
                                        className="
                                            flex
                                            items-center
                                            gap-3
                                        "
                                    >

                                        <div className="
                                            w-2
                                            h-2
                                            rounded-full
                                            bg-emerald-500
                                        " />

                                        <span className="
                                            text-sm
                                            text-slate-700
                                        ">
                                            {feature}
                                        </span>

                                    </div>

                                ))}

                            </div>

                        </div>

                    );
                })}

            </div>

        </section>

    );
}